export const GET_ALL_JACKPOTS = "GET_ALL_JACKPOTS";
export const GET_ALL_JACKPOTS_RESPONSE_SUCCESS =
  "GET_ALL_JACKPOTS_RESPONSE_SUCCESS";
